// extracted by mini-css-extract-plugin
export default {"panel":"SMLStatsUnavailable_panel__keYzY","text":"SMLStatsUnavailable_text__9JpjM"};